import { createSelector } from "reselect";

const getAction = state => state.get("actionReducer");

export const selectMagicLink = createSelector([getAction], action => {
  return action.get("magicLink").toJS();
});
